import {
  BufferGeometry,
  InterleavedBuffer,
  InterleavedBufferAttribute,
  Uint32BufferAttribute,
  Vector3,
} from "three";

const bakePathsGeometry = (particlePaths, params) => {

  let vertexCount = 0;
  const vertexData = [];
  const indexData = [];

  if (particlePaths == undefined) return;

  particlePaths.forEach((path, pathNo) => {
    const halfWidth = params.lineWidth + params.lineWidth / 2;

    if (path.length < params.lineLengthMinimalDrop) return;

    const random = 1 + Math.random();
    const totalTime = path.length;

    for (let i = 0; i < path.length - 1; i++) {
      if (path.length < params.lineLengthMinimalDrop) continue;

      const currentPoint = new Vector3(path[i].x, path[i].y, path[i].z);
      const nextPoint = new Vector3(
        path[i + 1].x,
        path[i + 1].y,
        path[i + 1].z
      );

      // Ensure valid points
      /* if (!currentPoint.isVector3 || !nextPoint.isVector3) {
        console.error("Invalid point data:", currentPoint, nextPoint);
        continue;
      }*/

      const direction = new Vector3()
        .subVectors(nextPoint, currentPoint)
        .normalize();

      const normal = new Vector3(-direction.y, direction.x, 0).normalize();

      let strokeSize = halfWidth * (1 - Math.exp(-5 * (i / path.length))); //halfWidth *  Math.exp(-5 * ( path.length/i)); //Math.sin(i/path.length*Math.PI/2);

      const p1 = new Vector3().addVectors(
        currentPoint,
        normal.clone().multiplyScalar(strokeSize)
      );
      const p2 = new Vector3().addVectors(
        currentPoint,
        normal.clone().multiplyScalar(-strokeSize)
      );
      const p3 = new Vector3().addVectors(
        nextPoint,
        normal.clone().multiplyScalar(strokeSize)
      );
      const p4 = new Vector3().addVectors(
        nextPoint,
        normal.clone().multiplyScalar(-strokeSize)
      );

      const t0 = i;
      const t1 = i + 1;
      const speed = 3 / (t1 - t0);

      [p1, p2, p3, p4].forEach((p, j) => {


        vertexData.push(
          p.x,
          p.y,
          p.z,
          normal.x,
          normal.y,
          t0,
          t1,
          totalTime,
          speed,
          random,
          currentPoint.z,
          10
        );
      });

      const offset = vertexCount * 4;
      indexData.push(offset, offset + 1, offset + 2);
      indexData.push(offset + 1, offset + 3, offset + 2);

      indexData.push();
      vertexCount++;
    }
  });

  const geometry = new BufferGeometry();
  const interleavedBuffer = new InterleavedBuffer(
    new Float32Array(vertexData),
    12
  ); // 10 floats per vertex

  geometry.setAttribute(
    "position",
    new InterleavedBufferAttribute(interleavedBuffer, 3, 0, false)
  );
  geometry.setAttribute(
    "a_Extrude",
    new InterleavedBufferAttribute(interleavedBuffer, 2, 3, false)
  );
  geometry.setAttribute(
    "a_Side",
    new InterleavedBufferAttribute(interleavedBuffer, 1, 5, false)
  );
  geometry.setAttribute(
    "a_Time",
    new InterleavedBufferAttribute(interleavedBuffer, 1, 6, false)
  );
  geometry.setAttribute(
    "a_TotalTime",
    new InterleavedBufferAttribute(interleavedBuffer, 1, 7, false)
  );
  geometry.setAttribute(
    "a_Speed",
    new InterleavedBufferAttribute(interleavedBuffer, 1, 8, false)
  );
  geometry.setAttribute(
    "a_Random",
    new InterleavedBufferAttribute(interleavedBuffer, 1, 9, false)
  );

  geometry.setAttribute(
    "a_Power",
    new InterleavedBufferAttribute(interleavedBuffer, 1, 10, false)
  );
  geometry.setAttribute(
    "a_Power2",
    new InterleavedBufferAttribute(interleavedBuffer, 1, 11, false)
  );

  geometry.setIndex(new Uint32BufferAttribute(indexData, 1));

  return geometry;
};

export { bakePathsGeometry };
